import React, { FC, useEffect, useState } from 'react';
import { WidgetProps, useBi } from '@wix/yoshi-flow-editor';
import { classes } from './Widget.st.css';
import { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import { photoAlbumGalleryLoaded } from '@wix/bi-logger-photo-ugc/v2';

export type ControllerProps = {
  name: string;
  cssBaseUrl: string;
  locale: string;
  mobile: boolean;
  instance: string;
  instanceId: string;
  time: number;
  currentPage?: string;
  refreshSets: (data: any, options?: any) => void;
  goToPage: (
    controllerConfig: IWidgetControllerConfig,
  ) => (path: string) => void;
};

const Widget: FC<WidgetProps<ControllerProps>> = (props) => {
  const {
    refreshSets,
    goToPage,
    instance,
    instanceId,
    time: timeFromProps,
    currentPage,
  } = props;
  const bi = useBi();
  const [time, setTime] = useState(timeFromProps || new Date().getTime());
  const onMessage = ({ data }: any = {}) => {
    if (data.type === 'refreshData') {
      refreshSets(data.data);
    }
    if (data.type === 'goToPage') {
      goToPage(data.data);
    }
  };

  useEffect(() => {
    const loadingTime = new Date().getTime() - time;
    const isCover = window.location.href.indexOf('/set') === -1;
    if (isCover) {
      bi.report(
        photoAlbumGalleryLoaded({
          instance_id: instanceId,
          loading_time: loadingTime,
        }),
      );
    }
    window.addEventListener('message', onMessage);
    window.top.postMessage(
      {
        type: 'appLoaded',
        instance,
      },
      '*',
    );
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [goToPage]);

  useEffect(() => {
    if (time !== timeFromProps) {
      window.top.postMessage(
        {
          type: 'pageLoaded',
          currentPage: currentPage || null,
        },
        '*',
      );
      window.parent.postMessage(
        {
          type: 'pageLoaded',
          currentPage: currentPage || null,
        },
        '*',
      );
      window.parent.parent.postMessage(
        {
          type: 'pageLoaded',
          currentPage: currentPage || null,
        },
        '*',
      );
    }
    setTime(timeFromProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeFromProps, goToPage]);

  return (
    <div className={classes.header}>
      <h2 className={classes.h2}>Albums Gallery Place holder</h2>
    </div>
  );
};

export default Widget;
